// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5336 ? "b3a13d7d" : chunkId) + "." + {"2558":"b61a5e8adaeb5c6a","4587":"edc4beb6b99a0d88","4873":"8e8b8d75a468eaa3","5336":"45bcfec85db7db98","7280":"6454409ffe36a85e","9070":"eee023dd11359c88"}[chunkId] + ".js";
};